/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass('PrefabInstance')
export default class PrefabInstance
{
    @property({ readonly: true })
    public Path: string = '';

    @property({ type: cc.Boolean, visible: (function(): boolean { return !this.SceneNode; })})
    public set Create(value: boolean) { if (this.FnCreate) { this.FnCreate(); } }
    public get Create(): boolean { return false; }

    @property({ type: cc.Boolean, visible: (function(): boolean { return !!this.SceneNode; })})
    public set Destroy(value: boolean)
    {
        if (!this.SceneNode) { return; }
        this.SceneNode.destroy();
        this.SceneNode = null;
    }
    public get Destroy(): boolean { return false; }

    @property({ type: cc.Node, visible: (function(): boolean { return !!this.SceneNode; })})
    public SceneNode: cc.Node = null;

    public FnCreate: () => void = null;

    constructor(path: string = null, fnCreate: () => void = null)
    {
        if (path) { this.Path = path; }
        if (fnCreate) { this.FnCreate = fnCreate; }
    }
}
